import React, { useRef, useEffect } from 'react';
import mapboxgl  from '!mapbox-gl'  // eslint-disable-line import/no-webpack-loader-syntax
import EmployeesSection from "./Sections/EmployeesSection";
import PartnerSection from "./Sections/PartnerSection";
import PageLayout from "../../components/PageLayout/PageLayout";

export default function GaragePage(props) {
  const mapContainer = useRef(null);
  const map = useRef(null);
  const { configuration } = props;

  useEffect(() => {
    if (!configuration.garageLocation || !mapContainer.current) {
      return undefined;
    }

    if (map.current) {
      map.current.remove();
      map.current = null;
    }

    const isCoarse = Boolean(
      window.matchMedia && window.matchMedia('(pointer: coarse)').matches
    );

    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: 'mapbox://styles/mapbox/light-v10',
      center: getLocations(configuration.garageLocation),
      scrollZoom: false,
      boxZoom: false,
      dragRotate: false,
      dragPan: !isCoarse,
      keyboard: false,
      doubleClickZoom: false,
      touchZoomRotate: isCoarse,
      touchPitch: false,
      pitchWithRotate: false,
      attributionControl: true,
      zoom: isCoarse ? 15 : 16,
    });

    map.current.on("wheel", event => {
      if (event.originalEvent.ctrlKey) {
        event.originalEvent.preventDefault();
        map.current.scrollZoom.enable();
      } else {
        map.current.scrollZoom.disable();
      }
    });

    if (isCoarse) {
      const setPan = (event) => {
        const touches = event.originalEvent && event.originalEvent.touches;
        if (touches && touches.length >= 2) {
          map.current.dragPan.enable();
        } else {
          map.current.dragPan.disable();
        }
      };
      map.current.on('touchstart', setPan);
      map.current.on('touchend', () => map.current && map.current.dragPan.disable());
    }

    new mapboxgl.Marker({
      color: '#1b4995',
    })
      .setLngLat(getLocations(configuration.garageLocation))
      .addTo(map.current);

    const handleResize = () => {
      if (map.current) {
        map.current.resize();
      }
    };

    map.current.on('load', handleResize);
    const resizeTimer = window.setTimeout(handleResize, 80);
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);

    return () => {
      window.clearTimeout(resizeTimer);
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
      if (map.current) {
        map.current.remove();
        map.current = null;
      }
    };
  }, [configuration.garageLocation]);

  function getLocations(location) {
    if (!location || typeof location !== 'string') {
      return [8.5417, 47.3769];
    }

    var locSplit = location.split(',');

    locSplit[0] = parseFloat(locSplit[0]);
    locSplit[1] = parseFloat(locSplit[1]);

    return locSplit;
  }

  mapboxgl.accessToken = 'pk.eyJ1IjoiZ3Jpc29mdCIsImEiOiJja2g2Y3pneTcwcXB4MnFuc2ZiazN5NDZjIn0.tsgWmDl5DwREXrDhXjecBQ';

  return (
    <PageLayout
      configuration={configuration}
      title="Team"
      helmetTitle="Team & Garage | Sportplatzgarage Gutknecht – stop+go Davos"
      description="Lernen Sie das Team der Sportplatzgarage Gutknecht in Davos kennen – stop+go Partner für VW, Audi, SEAT, Škoda und CUPRA."
      path="/garage"
      includeLocalBusiness
      hero={false}
    >
      <div className="spg-map-wrap">
        <div ref={mapContainer} className="spg-map-hero" />
        {(configuration.mapsLink || configuration.mapsLinkText) ? (
          <div className="spg-map-card">
            <div className="spg-kicker">Standort</div>
            {configuration.mapsLinkText ? (
              <div
                className="spg-map-card-text"
                dangerouslySetInnerHTML={{ __html: configuration.mapsLinkText }}
              />
            ) : (
              <p>Sportplatzgarage Gutknecht</p>
            )}
            {configuration.mapsLink ? (
              <a
                className="spg-btn"
                href={configuration.mapsLink}
                target="_blank"
                rel="noreferrer"
              >
                Route öffnen
              </a>
            ) : null}
          </div>
        ) : null}
      </div>
      <EmployeesSection garageAboutText={configuration.garageAboutText}/>
      <PartnerSection partnerText={configuration.partnerText}/>
    </PageLayout>
  );
}
